import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddTransferTypeFormData } from "../form";

export const TransferTypeDescriptionField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddTransferTypeFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Description</Typography>
      <TextInput
        className="w-full"
        placeholder="Enter Description"
        maxLength={128}
        hasError={!!errors.description}
        {...register("description")}
      />
      <ErrorMessage errors={errors} name="description" />
    </div>
  );
};
